module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABJUlEQVR4AWOgC3is6/Zx+pL/MPDx3bSn960f3pIDMuCCn+aufKTuCNXw59nLZ24xr1LL/33/AdIwbfHLmHwgAjKAXKDg64yqp47hvx8/g2oAif789aag8al10K+7D4FciAYg4/eDJ0/tQl/n1kPMgmmAgc+L1wLt/bbzINBsIPq2/xiQ+2nBapg8QgMC/Dx/Feil9+1TP/TMemzg8ePsZYQcQgMq+PPk+SNVu4dKNr/vPAByCWj4dePOE2Pvd7U975onAm34eek6Pg1f1m0HOvrLxl0Q7tdt+4FWfV6xCZuGP3/fVncDzQbagGLh3YdPLALeFDcDgxGh4c/L1899El9G5f798vU/BgAKvkoqBUYUMLoQMQ0Mk/94wcepCx9pOTMMSgAA74WDOOKK6UgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/JE.png
// module id = 1174
// module chunks = 0